import type { Runner } from './types';

/**
 * Composite jobs are never dispatched — the scheduler skips them and their
 * status is derived from their children's statuses. This export exists so
 * the registry has an entry for every JobKind, but invoking it is a bug.
 */
export const compositeRunner: Runner = () => {
  throw new Error('Composite jobs must not be dispatched directly.');
};
